import dayjs from "dayjs";

interface TermDurationCheckProps {
    start?: string;
    end?: string;
    termValue?: number;
    termUnit?: string;
    providedPeriodValue: number;
    providedPeriodmUnit: string;
}

export const validateTermDuration = ({
    start,
    end,
    termValue,
    termUnit,
    providedPeriodValue,
    providedPeriodmUnit,
}: TermDurationCheckProps): boolean => {
    if (!termValue || !termUnit) return false;

    const unitToDays = (value: number, unit: string): number => {
        switch (unit?.toUpperCase()) {
            case "DAY":
                return value;
            case "WEEK":
                return value * 7;
            case "MONTH":
                return value * 30;
            case "YEAR":
                return value * 365;
            default:
                return value;
        }
    };

    const recurringTermDays = unitToDays(providedPeriodValue, providedPeriodmUnit);

    let actualTermDays: number | null = null;

    if (termValue && termUnit) {
        actualTermDays = unitToDays(termValue, termUnit);
    } else if (start && end) {
        const startDate = dayjs(start);
        const endDate = dayjs(end);
        if (startDate.isValid() && endDate.isValid()) {
            actualTermDays = Math.abs(endDate.diff(startDate, "day"));
        }
    }

    if (actualTermDays === null) return false;

    return actualTermDays <= recurringTermDays;
};